import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getApiUrl, apiList } from 'src/app/core/Constants/apiList';
import { DiagnosisDetailsFilter } from 'src/app/core/Models/interfaces/master-management/payloads/diagnosisDetailsFilter';
import { DiagnosisListFilter } from 'src/app/core/Models/interfaces/master-management/payloads/diagnosisListFilter';
import { ApiResponse } from 'src/app/core/Models/interfaces/responseData';

@Injectable({
  providedIn: 'root'
})
export class DiagnosisCodeService {

  constructor(private http: HttpClient) { }


  public getDiagnosisList(filterPayload: DiagnosisListFilter): Observable<ApiResponse> {
    const endpoint = getApiUrl(apiList.diagnosis.getDiagnosisList, filterPayload);
    return this.http.get<ApiResponse>(endpoint)
  }

  public getDiagnosisDetails(filterPayload: DiagnosisDetailsFilter): Observable<ApiResponse> {
    const endpoint = getApiUrl(apiList.diagnosis.getDiagonsisDetails, filterPayload);
    return this.http.get<ApiResponse>(endpoint);
  }

  public updateDiagnosis(filterPayload: { validityStart: string, validityEnd: string  }, id: number| string): Observable<ApiResponse>  {
    const endpoint=getApiUrl(apiList.diagnosis.updateDiagnosis,filterPayload,{id});
    return this.http.put<ApiResponse>(endpoint,'')
  }
}
